import { Component, OnInit, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';

import { NavLink } from '@classes/nav-link';
import { UiService } from '@services/ui.service';

@Component({
    selector: 'app-nav-list',
    templateUrl: './nav-list.component.html',
    styleUrls: ['./nav-list.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NavListComponent implements OnInit, OnDestroy {
    @Input() link: NavLink;
    @Input() isLittleMode: boolean;

    private rLoadingSub: Subscription;

    isRouteLoading: boolean;

    constructor(
        private uiSrv: UiService
    ) { }

    ngOnInit() {
        this.initSubscriptions();
    }

    private initSubscriptions(): void {
        this.rLoadingSub = this.uiSrv.routeLoadingStateChanged
        .subscribe(loadingState => {
            this.isRouteLoading = loadingState;
        });
    }

    ngOnDestroy() {
        if(this.rLoadingSub) {
            this.rLoadingSub.unsubscribe();
        }
    }
}
